import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Error from '../components/Error'
import Spinner from '../components/Spinner'
import { registerUser } from '../features/auth/authSlice'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

const RegisterScreen = () => {
  const { register, handleSubmit } = useForm()

  // Form submission
  const submitForm = (data) => {
    if (data.password !== data.confirmation) {
      alert('Password mismatch')
      return
    }
    // transform email string to lowercase to avoid case sensitivity issues during login
    data.email = data.email.toLowerCase()
    console.log(data)
    dispatch(registerUser(data));
  }

  // useSelectors
  const { loading, userInfo, error, success } = useSelector(
    (state) => state.auth
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()


  useEffect(() => {
    if (success) {
      // redirect user to login page if registration was successful
      navigate('/login');
    }
    // redirect authenticated user to profile screen
    if(userInfo?.username) {
      // console.log(userInfo)
      navigate('/user-profile')
    }
  }, [navigate, userInfo, success])

  return (
    <>
    {/* <Spinner /> */}
    <form onSubmit={handleSubmit(submitForm)}>
      {error && <Error>{error}</Error>}
      <div className='form-group'>
        <label className='text-[var(--text-white)]' htmlFor='username'>First Name</label>
        <input
          type='text'
          className='form-input '
          {...register('username')}
          required
        />
      </div>
      <div className='form-group'>
        <label className='text-[var(--text-white)]' htmlFor='email'>Email</label>
        <input
          type='email'
          className='form-input'
          {...register('email')}
          required
        />
      </div>
      <div className='form-group'>
        <label className='text-[var(--text-white)]' htmlFor='password'>Password</label>
        <input
          type='password'
          className='form-input '
          {...register('password')}
          required
        />
      </div>
      <div className='form-group'>
        <label className='text-[var(--text-white)]' htmlFor='confirmation'>Confirm Password</label>
        <input
          type='password'
          className='form-input '
          {...register('confirmation')}
          required
        />
      </div>
      <button type='submit' className='button' disabled={loading}>
        {loading ? <Spinner /> : "Register"}
      </button>
    </form>
    </>
  )
}

export default RegisterScreen
